import styled from "@emotion/styled";
import TableInfo from "metabase/components/MetadataInfo/TableInfo";
export const WidthBoundTableInfo = styled(TableInfo)`
  width: 300px;
  font-size: 14px;
`;
